import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
import Shared100toGPA from "./Shared100toGPA";
import SharedGPAto100 from "./SharedGPAto100";
const TITLE =
  "Conversion de moyenne cumulative en pourcentage et vice versa - Conversion de 4 à 100";
const DESCRIPTION =
  "Conversion de moyenne cumulative en pourcentage et vice versa - Conversion de 4 à 100 pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "conversion de moyenne cumulative en pourcentage et vice versa conversion de 4 à 100, calculatrice conversion de moyenne cumulative en pourcentage et vice versa conversion de 4 à 100, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/grade100to4";
function Grade100to4() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <Shared100toGPA />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPAto100 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Tableau de conversion - Conversion de 4 à 100 et vice versa
                    </h2>{" "}
                  </u>
                  <p></p>
                  <table >
                    <thead>
                      <tr className="gpa-header">
                        <th>Note</th>
                        <th>Poids</th>
                        <th>Unité</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>A+</td>
                        <td>97-100</td>
                        <td>4.0</td>
                      </tr>
                      <tr>
                        <td>A</td>
                        <td>93-96</td>
                        <td>4.0</td>
                      </tr>
                      <tr>
                        <td>A-</td>
                        <td>90-92</td>
                        <td>3.7</td>
                      </tr>
                      <tr>
                        <td>B+</td>
                        <td>87-89</td>
                        <td>3.3</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>83-86</td>
                        <td>3.0</td>
                      </tr>
                      <tr>
                        <td>B-</td>
                        <td>80-82</td>
                        <td>2.7</td>
                      </tr>
                      <tr>
                        <td>C+</td>
                        <td>77-79</td>
                        <td>2.3</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>73-76</td>
                        <td>2.0</td>
                      </tr>
                      <tr>
                        <td>C-</td>
                        <td>70-72</td>
                        <td>1.7</td>
                      </tr>
                      <tr>
                        <td>D+</td>
                        <td>67-69</td>
                        <td>1.3</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>65-66</td>
                        <td>1.0</td>
                      </tr>
                      <tr>
                        <td>E/F</td>
                        <td>moins de 65</td>
                        <td>0.0</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Grade100to4;
